import { render } from "./AnalyticsNotesStructureTable.vue?vue&type=template&id=978b5c6c&ts=true"
import script from "./AnalyticsNotesStructureTable.vue?vue&type=script&lang=ts"
export * from "./AnalyticsNotesStructureTable.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__